
import { defineComponent, PropType } from 'vue';
import { SimpleAccountDto } from '@/api/models/account.dtos';
import { attachmentFileBaseUrl } from '@/api/common/httpApiClient';

export default defineComponent({
  name: 'AccountProfileImageButton',
  props: {
    simpleAccount: Object as PropType<SimpleAccountDto>,
  },
  computed: {
    profileImageUrl() {
      if (this.simpleAccount?.profileImageUrl) {
        return {
          backgroundImage: `url(${attachmentFileBaseUrl}${this.simpleAccount?.profileImageUrl})`,
        };
      } else {
        return {
          backgroundImage: `url(${require('@/assets/profile.svg')})`,
        };
      }
    },
  },
  methods: {
    async moveToBlog() {
      if (!this.simpleAccount?.guest) {
        this.$router.push(`/${this.simpleAccount?.blogId}`);
      }
    },
  },
});
